<template>
    <PopupRouterViewDetail label="Control Card Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Control Card" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-control-card-number" label-cols-lg="12"  label="Control Card Number" label-for="input-control-card-number" size="sm" :model.sync="model.controlCardNumber" :state="validateState('controlCardNumber')" :errorMessage="getErrorMessage(errorMessage.controlCardNumber, 'controlCardNumber')"  @change="updateData"  :isUpdatable="isManual" :isEditable="isManual"/>
					<app-input-combobox-autocomplete :options="controlCardTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Control Card Type" id="fieldset-control-card-type" size="sm" :model.sync="model.controlCardTypeId" :state="validateState('controlCardTypeId')" :errorMessage="getErrorMessage(errorMessage.controlCardTypeId, 'controlCardTypeId')"   :selected="model.controlCardType != null ? model.controlCardType.code : ''" @input="getControlCardTypes" @change="updateData"  :isUpdatable="isManual" :isEditable="isManual"  :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCardType" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
					<app-input-textbox id="fieldset-qty-case" label-cols-lg="12"  label="Qty Case" label-for="input-qty-case" size="sm" :model.sync="model.qtyCase" :state="validateState('qtyCase')" :errorMessage="getErrorMessage(errorMessage.qtyCase, 'qtyCase')"  @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual" />
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area" size="sm" :model.sync="model.areaId"   :selected="model.area != null ? model.area.code : ''" @input="getAreas" @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual"  :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" />
					<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Rack" id="fieldset-rack" size="sm" :model.sync="model.rackId"   :selected="model.rack != null ? model.rack.code : ''" @input="getRacks" @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual"  :isSelectMethodExists="true" @onSelectMethod="setSelectedRack" />
					<!-- <app-input-textbox id="fieldset-doc-no" label-cols-lg="12"  label="DocNo" label-for="input-doc-no" size="sm" :model.sync="model.docNo" :state="validateState('docNo')" :errorMessage="getErrorMessage(errorMessage.docNo, 'docNo')"  @change="updateData"  :isUpdatable="true"  :isEditable="true" /> -->
					<!-- <app-input-textbox id="fieldset-status" label-cols-lg="12"  label="Status" label-for="input-status" size="sm" :model.sync="model.status"  @change="updateData"  :isUpdatable="true"  :isEditable="true" /> -->
					<app-input-datetimepicker id="fieldset-receiving-date" label-cols-lg="12"  label="Receiving Date" size="sm" :model.sync="model.receivingDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual" />
					<!-- <app-input-textbox id="fieldset-transaction-type" label-cols-lg="12"  label="Transaction Type" label-for="input-transaction-type" size="sm" :model.sync="model.transactionType"  @change="updateData"  :isUpdatable="true"  :isEditable="true" /> -->
					<!-- <app-input-textbox id="fieldset-transaction-id" label-cols-lg="12"  label="Transaction Id" label-for="input-transaction-id" size="sm" :model.sync="model.transactionId"  @change="updateData"  :isUpdatable="true"  :isEditable="true" /> -->
					<!-- <app-input-textbox id="fieldset-revisi" label-cols-lg="12"  label="Revisi" label-for="input-revisi" size="sm" type="number" :model.sync="model.revisi"  @change="updateData"  :isUpdatable="true"  :isEditable="true" /> -->
					<!-- <app-input-combobox-autocomplete :options="originalControlCardNumbers" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card Number" id="fieldset-control-card-number" size="sm" :model.sync="model.originalControlCardId"   :selected="model.originalControlCard != null ? model.originalControlCard.controlCardNumber : ''" @input="getOriginalControlCards" @change="updateData"  :isUpdatable="true"  :isEditable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedQcStatus" /> -->

				</b-col>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-pack-sequence" label-cols-lg="12"  label="Pack Sequence" label-for="input-pack-sequence" size="sm" type="number" :model.sync="model.packSequence"  @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual" />
					<app-input-textbox id="fieldset-total-pack" label-cols-lg="12"  label="Total Pack" label-for="input-total-pack" size="sm" type="number" :model.sync="model.totalPack"  @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual" />
					<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Control Card Status" id="fieldset-control-card-status" size="sm" :model.sync="model.controlCardStatusId"   :selected="model.controlCardStatus != null ? model.controlCardStatus.name : ''" @input="getControlCardStatuss" @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual"  :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCardStatus" />
					<app-input-combobox-autocomplete :options="qcStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Qc Status" id="fieldset-qc-status" size="sm" :model.sync="model.qcStatusId"   :selected="model.qcStatus != null ? model.qcStatus.name : ''" @input="getQcStatuss" @change="updateData"  :isUpdatable="isManual"  :isEditable="isManual"  :isSelectMethodExists="true" @onSelectMethod="setSelectedQcStatus" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorSubcontId" :selected="model.vendorSubcont != null ? model.vendorSubcont.code : ''" @input="getVendors" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" :isUpdatable="isManual" :isEditable="isManual" />
					<app-input-datetimepicker id="fieldset-delivery-date" label-cols-lg="12" label="Delivery Date" size="sm" :model.sync="model.deliveryDate" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isUpdatable="isManual" :isEditable="isManual" />
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

		<template #modal-left-button>
			<b-button @click="printCard()" size="sm" class="float-right" variant="primary">
				<b-icon-printer class="mr-1" /> Print Card 
			</b-button>
		</template>
        <b-overlay :show="isBusy" no-wrap>
		</b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardList from '@/models/ControlCard/ControlCardList';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCardType from '@/models/ControlCardType/ControlCardType';
import ControlCardTypeFilter from '@/filters/ControlCardType/ControlCardTypeFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import QcStatus from '@/models/QcStatus/QcStatus';
import QcStatusFilter from '@/filters/QcStatus/QcStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			controlCardNumber: {required},
			controlCardTypeId: {required},
			qtyCase: {required},
			docNo: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				controlCardNumber: { required : "Control Card Number is Required."},
				controlCardTypeId: { required : "Control Card Type is Required."},
				qtyCase: { required : "Qty Case is Required."},
				docNo: { required : "DocNo is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterControlCard : null,
			currentControlCardPage : 1,
			controlCardPageSize: 10,
			sortByControlCard: '',
			sortDescControlCard: '',
			controlCardTypes: [],
			isControlCardTypeComboLoading: false,
			parts: [],
			isPartComboLoading: false,
			areas: [],
			isAreaComboLoading: false,
			racks: [],
			isRackComboLoading: false,
			controlCardStatuss: [],
			isControlCardStatusComboLoading: false,
			qcStatuss: [],
			originalControlCardNumbers: [],
			isQcStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			vendors: [],
			isManual: true,

		}
	},
	methods : {
		async printCard(){
			this.isBusy = true;
			let this_ = this;
			// console.log('controlCardId',controlCardId)
			try {
				let ids = [];
				ids.push(this.modelId);
				let result = await ControlCard.printControlCard(this_, ids)
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}
		},
		getOriginalControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			if (this.filter.originalControlCardId != null && input == '') {
				filter.id = this.filter.originalControlCardId;
			}
			ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.originalControlCardNumbers = result.data
					}
				})
				.catch(error => { });
		},
		setIsManual() {
			if(this.model != null && this.model.status == 'MANUAL')
				this.isManual = true;
		},
		getControlCard : async function(id) {
			this.isBusy = true;
			await ControlCard.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();
				this.setIsManual();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadControlCard = true;
			this.filterControlCard.id = this.modelId;
			ControlCard.downloadDataDetail(this, this.filterControlCard).then(result => {
				this.isDownloadControlCard = false;
			}).catch(error => { this.isDownloadControlCard = false; })
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.ControlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCardTypes : async function(input) {
			let filter = new ControlCardTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ControlCardType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCardType(item) {
			if(item == undefined || item == null) {
				this.model.controlCardTypeId = null;
				this.model.controlCardType = null;
			} else {
				this.model.controlCardTypeId = item.id;
				this.model.controlCardType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.model.areaId = null;
				this.model.area = null;
			} else {
				this.model.areaId = item.id;
				this.model.area = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorSubcontId = null;
				this.model.vendorSubcont = null;
			} else {
				this.model.vendorSubcontId = item.id;
				this.model.vendorSubcont = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedRack(item) {
			if(item == undefined || item == null) {
				this.model.rackId = null;
				this.model.rack = null;
			} else {
				this.model.rackId = item.id;
				this.model.rack = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCardStatus(item) {
			if(item == undefined || item == null) {
				this.model.controlCardStatusId = null;
				this.model.controlCardStatus = null;
			} else {
				this.model.controlCardStatusId = item.id;
				this.model.controlCardStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getQcStatuss : async function(input) {
			let filter = new QcStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			QcStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.qcStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedQcStatus(item) {
			if(item == undefined || item == null) {
				this.model.qcStatusId = null;
				this.model.qcStatus = null;
			} else {
				this.model.qcStatusId = item.id;
				this.model.qcStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedOriginalControlCard(item) {
			if(item == undefined || item == null) {
				this.model.originalControlCardId = null;
				this.model.originalControlCard = null;
			} else {
				this.model.originalControlCardId = item.id;
				this.model.originalControlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.controlCardInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ControlCard.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'controlcardindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ControlCard.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'controlcardindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ControlCard.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getControlCard(id);
					});
				}
			});
		},
		onHidden() {
			this.getControlCards();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterControlCard = new ControlCardFilter();
		//this.getControlCardTypes();
		//this.getParts();
		//this.getAreas();
		//this.getRacks();
		//this.getControlCardStatuss();
		//this.getQcStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getControlCard(id);
			} else {
				this.modelId = id;
				this.getControlCard(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
